import React, { Component } from "react";
import Image from "../utils/Image";
import { Row, Col, Button, Collapse } from "reactstrap";

import "./professional.css";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import * as Actions from "../../actions/index";
import { getSubcategories } from "../../providers/categoryProvider";

class ProfessionalList extends Component {
  constructor() {
    super();
    this.state = {
      selectedCategory: null,
      subcategories: []
    };
  }

  toggle = (name, value) => {
    this.setState({ [name]: !value });
  };

  selectCategory = async category => {
    if (
      this.state.selectedCategory &&
      category._id === this.state.selectedCategory._id
    ) {
      this.setState({ selectedCategory: null });
      return;
    }

    //this.props.doGetSubcategories(category.ref.id);
    const subcategories = await getSubcategories(category._id);
    if (subcategories.error) {
      this.setState({ selectedCategory: category });
      return;
    }

    this.setState({ selectedCategory: category, subcategories });
  };

  gotToProfile(params) {
    this.props.doCatchProfessional(params);
    this.props.history.push({
      pathname: `profissional/${params._id}`,
      state: { professional: params, category_name: this.props.category }
    });
  }

  render() {
    /* let subcategories = [];
    this.props.subcategories.forEach(item => {
      if (
        this.state.selectedCategory &&
        item.category.parentCategoryId === this.state.selectedCategory.ref.path
      ) {
        subcategories.push(
          <React.Fragment key={item.ref.id}>
            <Link
              to={`/categoria/${item.ref.id}/profissionais`}
              className="collapse-item"
            >
              {item.category.name}
            </Link>
            <br />
          </React.Fragment>
        );
      }
    }); */

    return (
      <Row className="pf-main-container row">
        <div className="menu-container">
          <Col className="show-if-mobile">
            <h2 className="orange m-0">{this.props.categoryName}</h2>
            <br />
            <button
              className="collapse-link"
              type="button"
              data-toggle="collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() =>
                this.toggle("collapseMobile", this.state.collapseMobile)
              }
            >
              <span>Especialidades</span>
            </button>
            <Collapse
              isOpen={this.state.collapseMobile}
              className="collapse-container"
            >
              {this.props.categories.map(item => (
                <React.Fragment key={item._id}>
                  <Link
                    to={`/categoria/${item._id}/profissionais`}
                    className="collapse-item"
                  >
                    {item.name}
                  </Link>
                  <br />
                </React.Fragment>
              ))}
            </Collapse>
          </Col>
          <Col className="hide-if-mobile">
            <h2 className="orange m-0">{this.props.categoryName}</h2>
            <br />
            {this.props.groups.map(group => {
              return (
                <React.Fragment key={group._id}>
                  <h4 className="orange">{group.name}</h4>
                  {group.categories.map(item => {
                    /* if (item.category.parentGroupId !== group._id) return null; */
                    return (
                      <React.Fragment key={item._id}>
                        {item.hasSubcategory ? (
                          <React.Fragment>
                            <button
                              className="collapse-link"
                              type="button"
                              data-toggle="collapse"
                              aria-expanded="false"
                              aria-label="Toggle navigation"
                              onClick={() => this.selectCategory(item)}
                            >
                              <span>{item.name}</span>
                            </button>
                            <Collapse
                              isOpen={
                                this.state.selectedCategory &&
                                this.state.selectedCategory._id === item._id
                                  ? true
                                  : false
                              }
                              className="collapse-container"
                            >
                              {this.state.subcategories.map(subcategory => (
                                <React.Fragment key={subcategory._id}>
                                  <Link
                                    to={`/categoria/${subcategory._id}/profissionais`}
                                    className="collapse-item"
                                  >
                                    {subcategory.name}
                                  </Link>
                                  <br />
                                </React.Fragment>
                              ))}
                              {/* subcategories */}
                              {/* <Link className="collapse-item">Direito Constitucional</Link>
                                                    <br /> */}
                            </Collapse>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Link
                              to={`/categoria/${item._id}/profissionais`}
                              className="collapse-link no-link"
                            >
                              {item.name}
                            </Link>
                            <br />
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </Col>
        </div>
        <div className="row category-professional-container">
          {this.props.list.map((item, index) => {
            return (
              <Col
                sm="3"
                className="pf-item"
                key={index.toString()}
                onClick={() => this.gotToProfile(item)}
              >
                <Image
                  src={item.userId.profilePhoto}
                  alt={item.userId.firstName}
                  fallbackSrc={
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRHgsXqmtcr5Mf29K6Nmuj0mQTvD-d8YzeXV5_AXOF7yBL_KIDE"
                  }
                />
                <div className="pf-item-texto">
                  <p className="category">
                    {" "}
                    {item.userId.firstName} {item.userId.lastName}
                  </p>
                  <span className={item.userId.isOnline ? "on" : "off"}></span>
                </div>
              </Col>
            );
          })}
        </div>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    subcategories: state.category.subcategories
  };
};

const mapDispatchToProps = dispatch => {
  return {
    doCatchProfessional: prof => dispatch(Actions.catchProfessional(prof))
    //doGetSubcategories: (id) => dispatch(getSubcategories(id)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProfessionalList));
